import { pbx_module_breadcrumbs } from './_module';

const index = pbx_module_breadcrumbs
  .extend('pbx.phone-list.index')
  .add('pbx.breadcrumb.phone-list.index', { name: 'pbx.phone-list.index' });

const create = index
  .extend('pbx.phone-list.create')
  .add('pbx.breadcrumb.phone-list.create', { name: 'pbx.phone-list.create' });

const edit = index
  .extend('pbx.phone-list.edit')
  .add('pbx.breadcrumb.phone-list.edit', { name: 'pbx.phone-list.edit' });

export const pbx_phone_lists_breadcrumbs = [index, create, edit];
